import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "className", "type", "iconKey", "value", "onBlur", "onChange", "onFocus", "onKeyUp", "autoFocus"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Icon from './Icon';
import { twMerge } from 'tailwind-merge';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SearchInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    iconKey = _ref.iconKey,
    value = _ref.value,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onKeyUp = _ref.onKeyUp,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "search-bar",
    className: "relative w-full flex-1 rounded-sm",
    children: [/*#__PURE__*/_jsx("input", _objectSpread({
      ref: ref,
      type: "search",
      "aria-label": props.placeholder,
      value: value,
      onChange: onChange,
      onKeyUp: onKeyUp,
      onFocus: onFocus,
      onBlur: onBlur,
      className: twMerge('form-input focus-ring block size-10 w-full rounded-sm border-0 bg-gray-200 py-1.5 ps-10 text-sm/6 text-gray-600 placeholder:text-gray-400 focus:ring-0 dark:bg-gray-200 dark:placeholder:text-gray-500', className),
      autoFocus: autoFocus
    }, props)), iconKey ? /*#__PURE__*/_jsx("div", {
      className: "pointer-events-none absolute inset-y-0 start-0 flex items-center ps-2",
      children: /*#__PURE__*/_jsx(Icon, {
        iconKey: iconKey,
        className: "text-gray-600"
      })
    }) : null]
  });
});
export default SearchInput;